/* Neubau D · Vorrat-Ansicht der Produktseite (product.vorrat1000).
   Rechnung: Knöpfe 1/2/3/5 Filter am Tag tauschen nur Texte, die Liquid vorgerechnet hat (data-dv-calc-data).
   „Erst kleiner anfangen?“: öffnet das Blatt (<dialog>) mit der kleinen Packung; Farbe wählen tauscht Bild und data-kd-add.
   In die Tüte macht d-kd.js ([data-kd-add]); nach kd:cart-added schließt das Blatt, die Tüte öffnet d-cart.js. */
(() => {
  const init = (root) => {
    if (root.dataset.dvReady) return;
    root.dataset.dvReady = '1';

    /* ---------- Rechnung ---------- */
    const calc = root.querySelector('[data-dv-calc]');
    let days = {};
    try { days = JSON.parse(calc?.querySelector('[data-dv-calc-data]')?.textContent || '{}'); } catch (e) { days = {}; }
    const setDay = (d) => {
      const t = days[d]; if (!t) return;
      calc.querySelectorAll('[data-dv-day]').forEach((b) => b.setAttribute('aria-checked', String(b.dataset.dvDay === d)));
      const h = calc.querySelector('.dv-calc__h'); if (h) h.innerHTML = t.title;
      const note = calc.querySelector('[data-dv-note]'); if (note) note.innerHTML = t.note;
      root.querySelectorAll('[data-dv-r]').forEach((el) => { el.textContent = t.r; });
      root.querySelectorAll('[data-dv-rc]').forEach((el) => { el.textContent = t.rc; });
      root.querySelectorAll('[data-dv-at]').forEach((el) => { el.textContent = t.at; });
      root.querySelectorAll('[data-dv-fine]').forEach((el) => { el.textContent = t.fine; });
    };
    calc?.addEventListener('click', (e) => { const b = e.target.closest('[data-dv-day]'); if (b) setDay(b.dataset.dvDay); });
    calc?.addEventListener('keydown', (e) => {
      if (!['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].includes(e.key) || !e.target.closest('[data-dv-day]')) return;
      const list = [...calc.querySelectorAll('[data-dv-day]')];
      const i = list.indexOf(e.target) + (e.key === 'ArrowLeft' || e.key === 'ArrowUp' ? -1 : 1);
      const next = list[(i + list.length) % list.length];
      e.preventDefault(); next.focus(); setDay(next.dataset.dvDay);
    });

    /* ---------- Blatt kleine Packung ---------- */
    const dlg = root.querySelector('[data-dv-sheet]');
    if (!dlg || typeof dlg.showModal !== 'function') return;
    let data = { variants: [] };
    try { data = JSON.parse(dlg.querySelector('[data-dv-sheet-data]')?.textContent || '{}'); } catch (e) { /* Blatt bleibt bei der ersten Variante */ }
    let opener = null;
    root.querySelectorAll('[data-dv-open]').forEach((a) => a.addEventListener('click', (e) => {
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.button > 0) return;
      e.preventDefault(); opener = a; dlg.showModal();
    }));
    const close = () => { if (dlg.open) dlg.close(); };
    dlg.addEventListener('close', () => { opener?.focus({ preventScroll: true }); });
    dlg.querySelector('[data-dv-close]')?.addEventListener('click', close);
    dlg.addEventListener('click', (e) => { if (e.target === dlg) close(); });

    const add = dlg.querySelector('[data-dv-add]');
    const label = dlg.querySelector('[data-dv-label]');
    const out = dlg.querySelector('[data-dv-qty] output');
    const less = dlg.querySelector('[data-dv-less]');
    let qty = 1;
    const setQty = (q) => {
      qty = Math.max(1, Math.min(99, q));
      if (out) out.textContent = qty;
      if (less) less.disabled = qty <= 1;
      if (add?.dataset.kdAdd) add.dataset.kdQty = qty;
    };
    less?.addEventListener('click', () => setQty(qty - 1));
    dlg.querySelector('[data-dv-more]')?.addEventListener('click', () => setQty(qty + 1));

    const ci = data.colorIndex;
    dlg.querySelectorAll('[data-dv-value]').forEach((sw) => sw.addEventListener('click', () => {
      const val = sw.dataset.dvValue;
      dlg.querySelectorAll('[data-dv-value]').forEach((x) => x.setAttribute('aria-checked', String(x === sw)));
      const name = dlg.querySelector('[data-dv-color]'); if (name) name.textContent = val;
      const v = (data.variants || []).find((x) => x.options[ci] === val);
      if (!v || !add) return;
      const img = dlg.querySelector('[data-dv-img]');
      if (img && v.img) { img.removeAttribute('srcset'); img.src = v.img; }
      if (v.available) {
        add.disabled = false; add.dataset.kdAdd = v.id; add.dataset.kdQty = qty;
        if (label) label.textContent = data.add;
      } else {
        add.disabled = true; delete add.dataset.kdAdd;
        if (label) label.textContent = data.soldOut;
      }
    }));
    document.addEventListener('kd:cart-added', (e) => { if (e.detail?.button === add) setTimeout(close, 600); });
  };
  const run = () => document.querySelectorAll('.dp--vorrat').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', run);
})();
